export const CANDIDATE_STATUS_SELECT = [
    { value: 2, name: 'Date', langKey: "date" },
    { value: 3, name: 'Score', langKey: "score" },
];
